import { Apollo, gql } from "apollo-angular";

import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { ActivatedRoute, Router } from "@angular/router";

import { SubscriptionStatus } from "../../apis/networkdashboard/graphql/graphql";
import { FooterComponent } from "../../components/common/footer/footer";
import { LoaderComponent } from "../../components/common/loader/loader";
import { NavigationComponent } from "../../components/common/navigation/navigation";
import { AuthService } from "../../services/authservice";

const FIND_SUBSCRIPTION_TAG = gql`
  query FindSubscriptionTag($subscriptionId: UUID!) {
    subscriptionStatus(subscriptionId: $subscriptionId) {
      productTag
      productType
    }
  }
`;

@Component({
  selector: "page-subscription-detail-redirection",
  templateUrl: "subscription-detail-redirection.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FooterComponent, LoaderComponent, NavigationComponent],
})
export class SubscriptionDetailRedirectionPage {
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private auth = inject(AuthService);
  private apollo = inject(Apollo);

  constructor() {
    this.auth.userLoaded.pipe(takeUntilDestroyed()).subscribe(() => this.init());
  }

  private init() {
    const subscriptionId = this.route.snapshot.paramMap.get("subscriptionId");
    if (!subscriptionId) {
      this.router.navigate(["/notfound"]);
      return;
    }
    this.queryBaseSubscription(subscriptionId);
  }

  private queryBaseSubscription(subscriptionId: string) {
    this.apollo
      .query<{ subscriptionStatus: SubscriptionStatus }>({
        query: FIND_SUBSCRIPTION_TAG,
        variables: {
          subscriptionId,
        },
        errorPolicy: "all",
      })
      .subscribe(({ data }) => {
        if (!data?.subscriptionStatus) {
          this.router.navigate(["/notfound"]);
          return;
        }

        const { productType, productTag } = data.subscriptionStatus;
        const path = phraseDetailPath(productType, productTag ?? productType, subscriptionId);
        this.router.navigate(path);
      });
  }
}

export function phraseDetailPath(productType: string, productTag: string, subscriptionId: string): string[] {
  if (productType === productTag) return ["/diensten", productType, subscriptionId];
  return ["/diensten", productType, productTag, subscriptionId];
}
